import LegalSection from './LegalSection';

function TermsPage() {
  return (
    <>
      <header className="hero legal-hero">
        <div>
          <p className="eyebrow">Terms of Service</p>
          <h1>Usage Guidelines & Responsibility</h1>
          <p className="sub">
            By using this app you agree to follow applicable laws and avoid posting illegal or inappropriate content. Default
            examples are for demo only and can be removed or replaced anytime.
          </p>
          <a className="primary" href="#/">
            Back to Home
          </a>
        </div>
      </header>
      <main className="content">
        <LegalSection />
      </main>
    </>
  );
}

export default TermsPage;

